// AI 免费功能已达使用上限（按人/天计）
export const AI_LIMIT_ERROR_CODE = 22004;
// 图像过大（像素过多、文件大小超限）
export const PIC_SIZE_ERROR_CODE = 22019;
// 图像解析失败（像素过少、下载超时、下载失败）
export const PIC_ANALYSIS_ERROR_CODE = 22020;
// AI 收费功能，额度已用尽（按付费周期计）
export const AI_CHARGE_LIMIT_ERROR_CODE = 22021;
